// src/pages/TransactionHistoryPage.tsx
// User-facing transaction history page - unified with Wallet style
// Canon Ref: CANON.md v1.3.0 (Design Canon, Frontend Data Canon)
// PRD: PRD-04-transactions-history.md

import { TransactionHistory } from '@/features/user/wallet';
import { MOTION } from '@/lib/motion';
import { semanticTokens } from '@packages/config/theme';
import { Page, PageHeader, PageContent } from '@supabank/ui';
import { motion } from 'framer-motion';
import { SFIcon } from '@/components/ui/sf-icon';
import { sfIcons } from '@/lib/sf-icons';
import { useNavigate } from 'react-router-dom';

interface TransactionHistoryPageProps {
  onBack?: () => void;
}

export function TransactionHistoryPage({ onBack }: TransactionHistoryPageProps) {
  const navigate = useNavigate();
  const handleBack = onBack || (() => navigate('/dashboard'));

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: MOTION.dur.standard, ease: MOTION.ease.standard }}
    >
      <Page data-ux-contract="canon" className={semanticTokens.spacing.lg}>
        {/* Header */}
        <PageHeader
          icon={() => <SFIcon icon={sfIcons.activity} />}
          title="Transaction History"
          subtitle="View your complete transaction history and conversion details"
          badge="User"
          showBackButton={true}
          onBack={handleBack}
        />

        {/* Content - Use unified TransactionHistory component */}
        <PageContent>
          <TransactionHistory showExportButton={true} />
        </PageContent>
      </Page>
    </motion.div>
  );
}
